import React, { useState } from "react";
import Proptypes from "prop-types";
import {
	CareerTrackOptionWrapper,
	Heading,
	Content,
	SectionContainer,
	Section,
	CtaWrapper,
} from "./style";
import { CtaButton } from "../../../Elements";

const CareerTrackOption = (props) => {
	const { careerTrack } = props;
	const [isExpanded, setIsExpanded] = useState(false);

	return (
		<CareerTrackOptionWrapper isExpanded={isExpanded}>
			<div
				className="careerTrackPreview"
				onClick={() => setIsExpanded(!isExpanded)}
			>
				<Heading>{careerTrack?.header}</Heading>
				<div className="expandArrow">
					<span></span>
				</div>
			</div>
			<div className="careerTrackComponents">
				<Content>{careerTrack.description}</Content>
				<SectionContainer>
					{careerTrack?.section.map((section, index) => (
						<Section key={index}>
							<p className="sectionHeading">{section?.title}</p>
							<p className="sectionDescription">{section?.description}</p>
						</Section>
					))}
				</SectionContainer>
				<CtaWrapper>
					<CtaButton
						className="careerTrackCta"
						cta={{
							type: careerTrack?.cta[0]?.type,
							text: careerTrack?.cta[0]?.text,
							link: {
								target: careerTrack?.cta[0]?.link?.target,
								type: careerTrack?.cta[0]?.link?.type,
								value: careerTrack?.cta[0]?.link?.link,
							},
						}}
					/>
				</CtaWrapper>
			</div>
		</CareerTrackOptionWrapper>
	);
};

CareerTrackOption.propTypes = {
	careerTrack: Proptypes.object,
};

CareerTrackOption.defaultProps = {
	careerTrack: {},
};

export default CareerTrackOption;
